import { GoogleAnalytics } from "./components/GoogleAnalytics";
import { ToastContainer } from "./components/ui/Toast";
import { AppDashboardProgressBridge } from "./modules/student-dashboard/hooks/AppDashboardProgressBridge";
import { AppTutorProgressBridge } from "./modules/tutor/hooks/AppTutorProgressBridge";
import { AppRoutes } from "./routes/AppRoutes";

function App() {
  return (
    <>
      <AppTutorProgressBridge />
      <AppDashboardProgressBridge />
      <GoogleAnalytics />
      <AppRoutes />
      <ToastContainer />
    </>
  );
}

export default App;
